
import ast from './ast';

const astPlugin = {
  install(Vue) {
    Vue.prototype.$astSupercorePlugin = {
      isAPP: ast.isAPP,
      getPlatform: ast.getPlatform,
      getAstConfig: ast.getAstConfig,
      initAPPShare: ast.initAPPShare,
      setAPPShare: ast.setAPPShare,
      goAPPShare: ast.goAPPShare,
      disableAPPShare: ast.disableAPPShare,
      gotoAPP: ast.gotoAPP,
    };
  },
};
export default astPlugin;
